import { createFileRoute, redirect } from '@tanstack/react-router'

// Back-compat: legacy alias for the retired Config Browser.
export const Route = createFileRoute('/showconfiguration')({
  beforeLoad: () => {
    throw redirect({ to: '/demoinfo' })
  },
})
